import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { sendGAEvent } from '@/utils/analytics';

const Head = ({ title, children }: { title: string; children: React.ReactNode }) => {
  const location = useLocation();

  useEffect(() => {
    document.title = title;

    sendGAEvent('page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title
    });
  }, [location]);

  return <>{children}</>;
};

export default Head;
